import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

import CreateIncidentAttachment from '../../../../components/CreateIncidentAttachment'
import ContextMenu from '../../../../components/ContextMenu'

export default function () {
  const navigate = useNavigate()
  const query = new URLSearchParams(useLocation().search)
  const incidentId = query.get('incidentId')

  return (
    <div className='container'>
      <ContextMenu renderTitle={() => <h1 className='title'>Create an incident attachment</h1>}></ContextMenu>
      <CreateIncidentAttachment
        incidentId={incidentId}
        onAttachmentCreated={() => navigate(`/incidents/${incidentId}`)}
      />
    </div>
  )
}
